// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetCheckConfigQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  checkGroupAndName: Types.Scalars["String"]["input"];
}>;

export type GetCheckConfigQuery = {
  __typename?: "GraphqlQuery";
  getCheckConfig: {
    __typename?: "CheckConfig";
    id: string;
    enabled: boolean;
    settings: any;
  };
};

export const GetCheckConfigDocument = gql`
  query GetCheckConfig($databaseId: ID!, $checkGroupAndName: String!) {
    getCheckConfig(
      databaseId: $databaseId
      checkGroupAndName: $checkGroupAndName
    ) {
      id
      enabled
      settings
    }
  }
`;

/**
 * __useGetCheckConfigQuery__
 *
 * To run a query within a React component, call `useGetCheckConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckConfigQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      checkGroupAndName: // value for 'checkGroupAndName'
 *   },
 * });
 */
export function useGetCheckConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCheckConfigQuery,
    GetCheckConfigQueryVariables
  > &
    (
      | { variables: GetCheckConfigQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCheckConfigQuery, GetCheckConfigQueryVariables>(
    GetCheckConfigDocument,
    options,
  );
}
export function useGetCheckConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCheckConfigQuery,
    GetCheckConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCheckConfigQuery, GetCheckConfigQueryVariables>(
    GetCheckConfigDocument,
    options,
  );
}
// @ts-ignore
export function useGetCheckConfigSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCheckConfigQuery,
    GetCheckConfigQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetCheckConfigQuery,
  GetCheckConfigQueryVariables
>;
export function useGetCheckConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCheckConfigQuery,
        GetCheckConfigQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetCheckConfigQuery | undefined,
  GetCheckConfigQueryVariables
>;
export function useGetCheckConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCheckConfigQuery,
        GetCheckConfigQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCheckConfigQuery,
    GetCheckConfigQueryVariables
  >(GetCheckConfigDocument, options);
}
export type GetCheckConfigQueryHookResult = ReturnType<
  typeof useGetCheckConfigQuery
>;
export type GetCheckConfigLazyQueryHookResult = ReturnType<
  typeof useGetCheckConfigLazyQuery
>;
export type GetCheckConfigSuspenseQueryHookResult = ReturnType<
  typeof useGetCheckConfigSuspenseQuery
>;
export type GetCheckConfigQueryResult = Apollo.QueryResult<
  GetCheckConfigQuery,
  GetCheckConfigQueryVariables
>;
